const HH_MM_REGEX = /^(?:[01]\d|2[0-3]):[0-5]\d$/;

export const toIsoDurationFromHourMinute = (value: string): string => {
    const normalized = (value ?? '').trim();

    if (!HH_MM_REGEX.test(normalized)) {
        return value;
    }

    const [hours, minutes] = normalized.split(':').map((part) => Number(part));
    const hasHours = hours > 0;
    const hasMinutes = minutes > 0;

    if (hasHours && hasMinutes) {
        return `PT${hours}H${minutes}M`;
    }

    if (hasHours) {
        return `PT${hours}H`;
    }

    if (hasMinutes) {
        return `PT${minutes}M`;
    }

    return 'PT0M';
};
